// extracted by mini-css-extract-plugin
export var container = "ValueBullets-module--container--3a904";
export var row = "ValueBullets-module--row--a5595";